import { Box, Button, Card, CardContent, Grid, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const data = [
  {
    title: "Dataset Explorer",
    description:
      "A tool to explore and filter 4000 text, video, and speech datasets, for their license, sources, creators, and other metadata.",
    link: "/data-provenance-explorer/dataset-explorer",
    // background: "linear-gradient(145deg, #A1DDFF, #B2E5FF)",
  },
  {
    title: "Web Data Explorer",
    description:
      "An explorer of the trends in data-use preferences from the websites commonly used to source AI data.",
    link: "/data-provenance-explorer/web-data-explorer",
    // background: "linear-gradient(145deg, #FAE4D4, #FCD3C3)",
  },
];

const DataProvenanceExplorer = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box sx={{ width: "100%", overflow: "auto", padding: { lg: "80px 0 100px", sm: "80px 0 100px", xs: "50px 0 100px" } }}>
      <Grid container spacing={3}>
        <Grid item lg={8} md={9} xs={12} sx={{ mx: "auto" }}>
          <Box sx={{ marginBottom: { lg: "80px", md: "50px", xs: "30px" }, textAlign: 'center' }}>
            <Typography
              sx={{
                fontSize: { lg: "96px", md: "80px", sm: "60px", xs: "48px" },
                lineHeight: '100%',
                fontWeight: '500',
                color: theme.customColors.primary.aliceBlue,
                marginBottom: { lg: "50px", md: "40px", xs: "30px" }
              }}
              variant="h1"
            >Data Provenance Explorer</Typography>
            <Typography
              sx={{
                fontSize: { lg: "36px", md: "32px", sm: "28px", xs: "24px" },
                lineHeight: '1.3',
                fontWeight: '500',
                color: theme.customColors.primary.aliceBlue,
                width: { lg: '85%', md: '100%' },
                mx: "auto"
              }}
            >Discover the datasets featured in our audit! The DPI Explorer tool enables you to filter and analyze language model training datasets effortlessly.</Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={{ xs: 3, md: 5, lg: 8 }} sx={{ justifyContent: 'center' }}>
        {data.map((d) => (
          <Grid item xl={5} lg={6} md={6} xs={12} key={d.title}>
            <Link to={d.link}>
              <Card sx={{
                color: theme.customColors.supplementary.darkBlue,
                borderRadius: '15px',
                ":hover": {
                  backgroundColor: theme.customColors.primary.lion,
                  "*": {
                    color: theme.customColors.supplementary.light
                  },
                  "svg path": {
                    fill: "#FFFFFF"
                  },
                },
              }}>
                <CardContent sx={{ padding: { lg: '30px', xs: '24px' }, minHeight: { lg: "766px", xs: "450px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography sx={{
                      fontSize: { lg: "36px", md: "32px", xs: "28px" },
                      lineHeight: '100%',
                      fontWeight: '700',
                      marginBottom: '25px'
                    }} variant="h4">
                      {d.title}
                    </Typography>
                    <Typography sx={{
                      fontSize: { lg: "24px", md: "22px", xs: "20px" },
                      lineHeight: '1.3',
                      fontWeight: '500',
                      width: { lg: "70%", md: "100%" }
                    }}>{d.description}</Typography>
                  </Box>
                  <Box sx={{
                    marginLeft: 'auto',
                  }}>
                    <Button
                      sx={{
                        backgroundColor: 'transparent',
                        ":hover": {
                          backgroundColor: 'transparent',
                        },

                      }}
                      onClick={() => navigate(d.link)}
                    >
                      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33 2C33 0.895429 32.1046 -1.63631e-06 31 -2.14208e-06L13 -5.40495e-07C11.8954 -1.21484e-06 11 0.89543 11 2C11 3.10457 11.8954 4 13 4L29 4L29 20C29 21.1046 29.8954 22 31 22C32.1046 22 33 21.1046 33 20L33 2ZM3.41421 32.4142L32.4142 3.41421L29.5858 0.585785L0.585786 29.5858L3.41421 32.4142Z" fill="#192C39" />
                      </svg>
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DataProvenanceExplorer;
